import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "./api";

const Ctx = createContext(null);

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("cgl_cart") || "[]"));
  const [mode, setMode] = useState(() => localStorage.getItem("cgl_mode") || "immersive");
  const [cartOpen, setCartOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => { localStorage.setItem("cgl_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("cgl_mode", mode); }, [mode]);

  const fetchMe = useCallback(async () => {
    if (!getToken()) return;
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { setToken(null); setUser(null); }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("cgl_ref", ref);
      api.post(`/partners/track/${ref}`).catch(() => {});
    }
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault(); setCmdOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const logout = () => { setToken(null); setUser(null); };

  const impersonate = async (userId) => {
    const { data } = await api.post(`/admin/impersonate/${userId}`);
    setToken(data.token); setUser(data.user); return data.user;
  };
  const stopImpersonate = async () => {
    const { data } = await api.post("/admin/stop-impersonate");
    setToken(data.token); setUser(data.user); return data.user;
  };

  const addToCart = (variant, product, qty = 1) => {
    setCart((c) => {
      const ex = c.find((x) => x.variant.id === variant.id);
      if (ex) return c.map((x) => x.variant.id === variant.id ? { ...x, qty: x.qty + qty } : x);
      return [...c, { variant, product, qty }];
    });
    setCartOpen(true);
  };
  const removeFromCart = (id) => setCart((c) => c.filter((x) => x.variant.id !== id));
  const updateQty = (id, qty) => setCart((c) => c.map((x) => x.variant.id === id ? { ...x, qty: Math.max(1, qty) } : x));
  const clearCart = () => setCart([]);

  return (
    <Ctx.Provider value={{
      user, login, signup, logout, fetchMe, impersonate, stopImpersonate,
      cart, addToCart, removeFromCart, updateQty, clearCart,
      mode, setMode,
      cartOpen, setCartOpen, aiOpen, setAiOpen, cmdOpen, setCmdOpen,
    }}>
      {children}
    </Ctx.Provider>
  );
};

export const useApp = () => useContext(Ctx);
